import TagManager from 'react-gtm-module';

const googleTagManagerInitialize = (googleTagManagerInfo) => {
  TagManager.initialize({
    gtmId: googleTagManagerInfo?.id,
    auth: googleTagManagerInfo?.auth,
    preview: googleTagManagerInfo?.preview,
  });
};

const sendDataToGTM = (payload) => {
  TagManager.dataLayer({
    dataLayer: payload,
  });
};

// The following constant list is based on Skooldio GTM events
// https://docs.google.com/presentation/d/1GqBu6ZF_RKRyCmNiFg6qb5JsWKSVKPdik1OqlCHanKA/edit#slide=id.g142a54f4bf9_0_96
const GTM_EVENT_NAME = {
  DISCUSSION_BUTTON_CLICK: 'discussion-button-click',
  REVIEW_BUTTON_CLICK: 'review-button-click',
  REVIEW_LATER_BUTTON_CLICK: 'review-later-button-click',
  REVIEW_START_BUTTON_CLICK: 'review-start-button-click',
  SOCIAL_SHARE_BUTTON_CLICK: 'social-share-button-click',
  SUBSECTION_CLICK: 'subsection-click',
  TRIAL_PURCHASE_CLICK: 'trial-purchase-click',
  TRIAL_SUBSECTION_CLICK: 'trial-subsection-click',
};

const GTM_DATA_LAYER_PROPERTY = {
  PRODUCT_TITLE: 'productTitle',
  SUBSECTION_TITLE: 'subsectionTitle',
  BUTTON_LOCATION: 'buttonLocation',
  SOCIAL_CHANNEL: 'socialChannel',
};

const GTM_SOCIAL_CHANNEL_NAME = {
  LINKEDIN: 'linkedin',
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
};

const GTM_BUTTON_LOCATION_NAME = {
  HEADER: 'header',
  FOOTER: 'footer',
  MODAL: 'modal',
};

export {
  googleTagManagerInitialize,
  sendDataToGTM,
  GTM_EVENT_NAME,
  GTM_DATA_LAYER_PROPERTY,
  GTM_SOCIAL_CHANNEL_NAME,
  GTM_BUTTON_LOCATION_NAME,
};
